import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Segment } from '../../../models/segment.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DisableWithoutPermissionDirective } from '../../../../../shared/directives/disable-without-permission.directive';
@Component({
  selector: 'app-segment-table',
  standalone: true,
  imports: [CommonModule, FormsModule, DisableWithoutPermissionDirective],
  templateUrl: './segment-table.component.html',
})
export class SegmentTableComponent {

  @Input() segments: Segment[] = [];
  @Input() selectedIds: number[] = [];
  @Input() isLoading: boolean = false;
  @Input() error: string = '';

  // Paginación
  @Input() page: number = 0;
  @Input() totalPages: number = 0;
  @Input() totalElements: number = 0;
  @Input() pageSize: number = 20;
  @Input() pageSizeOptions: number[] = [10, 20, 50, 100];
  @Output() pageSizeChange = new EventEmitter<number>();

  @Output() view = new EventEmitter<number>();
  @Output() edit = new EventEmitter<number>();
  @Output() duplicate = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() changeStatus = new EventEmitter<{ id: number; newStatus: string; action: string }>();

  @Output() toggleSelection = new EventEmitter<number>();
  @Output() toggleAll = new EventEmitter<Event>();
  @Output() openMoveFolder = new EventEmitter<void>();
  @Output() bulkDelete = new EventEmitter<void>();

  @Output() prevPage = new EventEmitter<void>();
  @Output() nextPage = new EventEmitter<void>();
  @Output() goToPage = new EventEmitter<number>();

  get hasPrevPage(): boolean { return this.page > 0; }
  get hasNextPage(): boolean { return this.page < this.totalPages - 1; }
  get pageDisplay(): number { return this.page + 1; }
  get pagesArray(): number[] { return Array.from({ length: this.totalPages }, (_, i) => i + 1); }

  onPageDisplayChange(pageDisplay: number): void {
    this.goToPage.emit(pageDisplay - 1);
  }

  isSelected(id: number): boolean {
    return this.selectedIds.includes(id);
  }

  get isAllSelected(): boolean {
    return this.segments.length > 0 && this.selectedIds.length === this.segments.length;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return 'No disponible';
    const utcDate = new Date(dateStr);
    if (isNaN(utcDate.getTime())) return 'Fecha inválida';

    const now = new Date();
    const diff = now.getTime() - utcDate.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) return 'Hace unos segundos';
    if (minutes < 60) return `Hace ${minutes} min`;
    if (hours < 24) return `Hace ${hours}h`;
    if (days === 1) return 'Hace 1 día';
    if (days < 7) return `Hace ${days}d`;

    return utcDate.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  getTypeBadge(type: string): { text: string, color: string } {
    if (type === 'DYNAMIC') return { text: 'Dinámica', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' };
    if (type === 'STATIC') return { text: 'Estática', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' };
    return { text: type, color: 'bg-gray-100 text-gray-700' };
  }

  getStatusBadge(status: string): { text: string, color: string } {
    switch (status) {
      case 'READY': return { text: 'Activo', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' };
      case 'DRAFT': return { text: 'Borrador', color: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400' };
      case 'CALCULATING': return { text: 'Calculando...', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' };
      case 'ERROR': return { text: 'Error', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' };
      case 'SUPPRESSED': return { text: 'Suprimido', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' };
      case 'ARCHIVED': return { text: 'Archivado', color: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400' };
      default: return { text: status, color: 'bg-gray-100 text-gray-700' };
    }
  }


}
